/**
 * @typedef {Object} RouteObject
 * @property {string} path
 * @property {boolean} exact
 */

/**
 *
 * @param {RouteObject[]} routes
 * @param {Location | string} location
 * @returns {RouteObject[] | null}
 */
export function matchRoutes(routes, location) {
  const pathname = typeof location === 'object' ? location.pathname : location
  if (!pathname) return null
  const match = routes.reduce((acc, route) => {
    const currentRoute = { ...route }
    if (currentRoute.exact) {
      if (currentRoute.path === pathname) {
        acc.push(route)
      }
      return acc
    }
    const regex = new RegExp(`^${currentRoute.path}/?.*`)
    const matchPartialRoute = regex.test(pathname)
    if (matchPartialRoute) {
      currentRoute.path = pathname
      acc.push(currentRoute)
    }
    return acc
  }, [])
  return match.length ? match : null
}
